<template>
  <div class="areas">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado árbol')">
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-if="!loading">
          <el-col :span="24" class="right" v-if="!$store.getters.user.readonly">
            <el-button size="medium" type="primary" @click="dialogCreateArea = true" icon="el-icon-edit">
              {{ $t("Agregar Área") }}
            </el-button>
          </el-col>
        </el-row>
        <br />
        <br />
        <el-row :gutter="15" v-if="!loading">
          <el-col :span="4">
            <div class="header" v-if="assets.length > 0">
              <span>{{ $t("Asset") }}</span>
            </div>
            <div v-for="(asset, index) in assets" :key="index">
              <div @click="setAsset(asset)">
                <el-col class="selection" :class="{ cursor: asset.n_operaciones > 0 ? true : false }" :span="21">{{
                  asset.nombre
                }} ({{ asset.n_operaciones }})</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="openEditAsset(asset)" class="imgEdit" v-if="isAdmin()" src="@/assets/edit.svg" width="20px"
                    height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="header" v-if="operaciones.length > 0">
              <span>{{ $t("Gerencias Generales") }}</span>
            </div>
            <div v-for="(operacion, index) in operaciones" :key="index">
              <div @click="setOperacion(operacion)">
                <el-col class="selection" :class="{
                  cursor: operacion.gerencias.length > 0 ? true : false,
                }" :span="21">{{ operacion.nombre }} ({{
  operacion.gerencias.length
}})</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="setSeleccion(false), openEditArea(operacion)" v-if="isAdmin()" class="imgEdit"
                    src="@/assets/edit.svg" width="20px" height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="header" v-if="gerencias.length > 0">
              <span>{{ $t("Gerencias") }}</span>
            </div>
            <div v-for="(gerencia, index) in gerencias" :key="index">
              <div @click="setGerencia(gerencia)">
                <el-col class="selection" :class="{
                  cursor:
                    gerencia.superintendencias.length > 0 ? true : false,
                }" :span="21">{{ gerencia.nombre }} ({{
  gerencia.superintendencias.length
}})</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="setSeleccion(false), openEditArea(gerencia)" v-if="isAdmin()" class="imgEdit"
                    src="@/assets/edit.svg" width="20px" height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="header" v-if="superintendencias.length > 0">
              <span>{{ $t("Superintendencias") }}</span>
            </div>
            <div v-for="(superintendencia, index) in superintendencias" :key="index">
              <div @click="setSuperintendencia(superintendencia)">
                <el-col class="selection" :class="{
                  cursor: superintendencia.areas.length > 0 ? true : false,
                }" :span="21">{{ superintendencia.nombre }} ({{
  superintendencia.areas.length
}})</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="setSeleccion(true), openEditArea(superintendencia)" v-if="isAdmin()" class="imgEdit"
                    src="@/assets/edit.svg" width="20px" height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="header" v-if="areas.length > 0">
              <span>{{ $t("Áreas") }}</span>
            </div>
            <div v-for="(area, index) in areas" :key="index">
              <div @click="setArea(area)">
                <el-col class="selection" :class="{ cursor: area.subareas.length > 0 ? true : false }" :span="21">{{
                  area.nombre
                }} ({{ area.subareas.length }})</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="setSeleccion(true), openEditArea(area)" v-if="isAdmin()" class="imgEdit"
                    src="@/assets/edit.svg" width="20px" height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="header" v-if="subAreas.length > 0">
              <span>{{ $t("Sub-Áreas") }}</span>
            </div>
            <div v-for="(subarea, index) in subAreas" :key="index">
              <div @click="setSubArea(subarea)">
                <el-col class="selection" :span="21">{{
                  subarea.nombre
                }}</el-col>
              </div>
              <el-col :span="3">
                <center v-if="!$store.getters.user.readonly">
                  <img @click="setSeleccion(true), openEditArea(subarea)" v-if="isAdmin()" class="imgEdit"
                    src="@/assets/edit.svg" width="20px" height="20px" />
                </center>
              </el-col>
            </div>
          </el-col>
        </el-row>

        <el-dialog append-to-body :title="$t('Modificar Estructura Organizacional')" :visible="dialogEditVisible"
          width="40%" :before-close="limpiarArea">
          <el-form :model="area" label-position="top">
            <el-form-item :label="$t('Nombre')" prop="nombre">
              <el-input class="with-help-box" v-model="area.nombre" :placeholder="$t('Ingresa nombre')" />
              <el-popover class="help-box" placement="right" :title="$t('Nombre')" width="200" trigger="hover"
                :content="$t('Escriba el nombre del área')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>

            <el-form-item :label="$t('Área padre')" prop="area_padre_id">
              <el-select v-model="area.area_padre_id" filterable class="full-width with-help-box"
                :placeholder="$t('Buscar por nombre')">
                <el-option v-for="optArea in [
                  { nombre: faenas[$store.getters.role.faena_id], _id: '' },
                ].concat(filtrarAreaPadres(areasTree, area))" :key="optArea._id" v-show="area.id !== optArea._id"
                  :label="optArea.nombre" v-bind:value="optArea._id" />
              </el-select>
              <el-popover class="help-box" placement="right" :title="$t('Área padre')" width="200" trigger="hover"
                :content="$t(
                  'Seleccione el área padre. En caso de estar ingresando un área padre, dejar en blanco.'
                )
                  ">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>

            <el-form-item :label="$t('Gerente')" prop="manager_id">
              <el-select size="large" v-model="area.manager_id" style="width: 60%" class="with-help-box" filterable
                :placeholder="$t('Buscar por nombre o RUT')">
                <el-option v-for="user in gerentes" :key="user._id" :label="user.nombre + ' ' + user.apellido + ' (' + user.rut + ')'
                  " :value="user._id" />
              </el-select>
              <el-button v-if="isAdmin()" style="margin-left: 15px" type="primary" @click="
                setearPerfilUsuario('manager'), (dialogUserVisible = true)
                ">Crear Gerente</el-button>
              <el-popover class="help-box" placement="right" :title="$t('Gerente')" width="200" trigger="hover"
                :content="$t('Seleccione el gerente del área')">
                <i style="margin-left: 5px" slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item v-if="hasSuperintendente !== false" :label="$t('Superintendente')" prop="super_id">
              <el-select style="width: 60%" size="large" v-model="area.super_id" class="with-help-box" filterable
                :placeholder="$t('Buscar por nombre o RUT')">
                <el-option v-for="user in superintendentes" :key="user._id" :label="user.nombre + ' ' + user.apellido + ' (' + user.rut + ')'
                  " :value="user._id" />
              </el-select>
              <el-button v-if="isAdmin()" style="margin-left: 15px" @click="
                setearPerfilUsuario('super'), (dialogUserVisible = true)
                " type="primary">{{ $t("Crear Superintendente") }}</el-button>
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i style="margin-left: 5px" slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item v-if="hasSuperintendente !== false" :label="$t('Superintendente')" prop="super_dos_id">
              <el-select style="width: 60%" size="large" v-model="area.super_dos_id" class="with-help-box" filterable
                :placeholder="$t('Buscar por nombre o RUT')">
                <el-option v-for="user in superintendentes" :key="user._id" :label="user.nombre + ' ' + user.apellido + ' (' + user.rut + ')'
                  " :value="user._id" />
              </el-select>
              <el-button v-if="isAdmin()" style="margin-left: 15px" @click="
                setearPerfilUsuario('super'), (dialogUserVisible = true)
                " type="primary">{{ $t("Crear Superintendente") }}</el-button>
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i style="margin-left: 5px" slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogEditVisible = false">{{
              $t("Cancelar")
            }}</el-button>
            <el-button :loading="loadingAction" type="primary" @click="editarArea()">{{ $t("Modificar") }}</el-button>
          </span>
        </el-dialog>

        <!--nuevo usuario-->
        <el-dialog :title="$t('Crear usuario')" :visible="dialogUserVisible" width="30%" append-to-body>
          <el-form label-position="top" :model="nuevoUsuario" ref="nuevoUsuario">
            <el-form-item :label="$t('Nombre')" prop="nombre">
              <el-input class="with-help-box" v-model="nuevoUsuario.nombre" :placeholder="$t('Ingresa nombre')" />
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="$t('Apellido')" prop="apellido">
              <el-input class="with-help-box" v-model="nuevoUsuario.apellido" :placeholder="$t('Ingresa apellido')" />
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="RUT" prop="rut">
              <el-input class="with-help-box" v-model="nuevoUsuario.rut" :placeholder="$t('Ingresa RUT')" />
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="E-mail" prop="email">
              <el-input class="with-help-box" v-model="nuevoUsuario.email" :placeholder="$t('Ingresa email')" />
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="Área" prop="area_id">
              <el-select style="width: 93%" v-model="nuevoUsuario.area_id" placeholder="Seleccione área">
                <el-option v-for="item in areasTree" :key="item._id" :label="item.nombre" :value="item._id"></el-option>
              </el-select>
              <el-popover class="help-box" placement="right" :title="$t('Superintendente')" width="200" trigger="hover"
                :content="$t('Seleccione el superintendente del área')">
                <i style="margin-left: 5px" slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="limpiarNuevoUsuario()">{{
              $t("Cancelar")
            }}</el-button>
            <el-button type="primary" @click="addGerenteSuperintendente()">{{
              $t("Crear")
            }}</el-button>
          </span>
        </el-dialog>
        <!--Nueva área-->
        <el-dialog :before-close="limpiarNuevaArea" :title="$t('Crear área')" :visible="dialogCreateArea" width="40%">
          <el-form :model="nuevaArea" label-position="top">
            <el-form-item :label="$t('Tipo de área')">
              <el-select filterable v-model="tipoArea" class="full-width with-help-box"
                :placeholder="$t('Buscar por tipo de área')">
                <el-option
                  v-for="tipo in (!isAdmin() && $store.getters.role.role === 'super') ? listTypeAreasSuper : listTypeAreasMEL"
                  :key="tipo.value" :label="tipo.label" v-bind:value="tipo.value" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="tipoArea && tipoArea !== 'gerencia_general'"
              :label="$t(`Seleccione ${traductionTypeArea[tipoArea]}`)" prop="area_padre_id">
              <el-select v-model="nuevaArea.area_padre_id" filterable class="full-width with-help-box"
                :placeholder="$t('Buscar por nombre')">
                <el-option v-for="area in tiposAreas" :key="area._id" :label="area.nombre" v-bind:value="area._id" />
              </el-select>
              <el-popover class="help-box" placement="right" :title="$t('Área padre')" width="200" trigger="hover"
                :content="$t(
                  'Seleccione el área padre. En caso de estar ingresando un área padre, dejar en blanco.'
                )
                  ">
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>

            <el-form-item v-if="tipoArea" :label="$t('Nombre')" prop="nombre">
              <el-input class="with-help-box" v-model="nuevaArea.nombre" :placeholder="$t('Ingresa nombre')" />
              <el-popover class="help-box" placement="right" :title="$t('Nombre')" width="200" trigger="hover"
                :content="$t('Escriba el nombre del área')">
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </el-form-item>

            <el-form-item :label="$t('Gerente')" v-if="tipoArea">
              <el-row>
                <el-col :span="16">
                  <el-select size="large" v-model="nuevaArea.manager_id" class="full-width with-help-box" filterable
                    :placeholder="$t('Buscar por nombre o RUT')">
                    <el-option v-for="user in gerentes" :key="user._id" :label="user.nombre +
                      ' ' +
                      user.apellido +
                      ' (' +
                      user.rut +
                      ')'
                      " :value="user._id" />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-button type="primary" class="w-100" v-if="isAdmin()" @click="
                    setearPerfilUsuario('manager'), (dialogUserVisible = true)
                    ">Crear Gerente</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="['superintendencia', 'area', 'subarea'].includes(tipoArea)"
              :label="$t('Superintendente')">
              <el-row>
                <el-col :span="16">
                  <el-select size="large" v-model="nuevaArea.super_id" class="full-width with-help-box" filterable
                    :placeholder="$t('Buscar por nombre o RUT')">
                    <el-option v-for="user in superintendentes" :key="user._id" :label="user.nombre +
                      ' ' +
                      user.apellido +
                      ' (' +
                      user.rut +
                      ')'
                      " :value="user._id" />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-button v-if="isAdmin()" @click="
                    setearPerfilUsuario('super'), (dialogUserVisible = true)
                    " type="primary" class="w-100">{{ $t("Crear Superintendente") }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="['superintendencia', 'area', 'subarea'].includes(tipoArea)"
              :label="$t('Superintendente')">
              <el-row>
                <el-col :span="16">
                  <el-select size="large" v-model="nuevaArea.super_dos_id" class="full-width with-help-box" filterable
                    :placeholder="$t('Buscar por nombre o RUT')">
                    <el-option v-for="user in superintendentes" :key="user._id" :label="user.nombre +
                      ' ' +
                      user.apellido +
                      ' (' +
                      user.rut +
                      ')'
                      " :value="user._id" />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-button v-if="isAdmin()" @click="
                    setearPerfilUsuario('super'), (dialogUserVisible = true)
                    " type="primary" class="w-100">{{ $t("Crear Superintendente") }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="limpiarNuevaArea()">{{
              $t("Cancelar")
            }}</el-button>
            <el-button :loading="loadingAction" type="primary" @click="crearArea()">{{ $t("Crear") }}</el-button>
          </span>
        </el-dialog>

        <el-dialog :before-close="limpiarArea" :title="$t('Modificar Asset')" :visible="dialogEditAsset" width="40%">
          <el-form :model="area" label-position="top">
            <el-form-item :label="$t('Nombre')">
              <el-input size="medium" v-model="area.nombre"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Asset President')">
              <el-input size="medium" v-model="area.asset_president"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="limpiarArea()">{{ $t("Cancelar") }}</el-button>
            <el-button :loading="loadingAction" @click="modificarAsset" type="primary">{{ $t("Modificar") }}</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane class="paddingBody content" :label="$t('Listado tabla')" v-if="[
        '5e41686693114800178f246f',
        '608c08fc3fdf700017e11c95',
        '5b929a761616050010f76dff',
        '59cbfb0c0a1d7d0011ba7860',
      ].includes($store.getters.user._id)
        ">
        <el-input :placeholder="$t('Búsqueda por nombre del área')" prefix-icon="el-icon-search" v-model="search"
          class="search" size="medium"></el-input>
        <br /><br /><br />
        <center v-if="loading_table">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <div v-else>
          <el-table row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray" :data="allAreas" stripe style="width: 100%">
            <el-table-column prop="nombre" label="Nombre"> </el-table-column>
            <el-table-column prop="area_padre_id" label="Área Padre">
              <template slot-scope="scope">
                <span v-if="scope.row.area_padre">{{
                  scope.row.area_padre.nombre
                }}</span>
                <el-tag v-else size="small" type="primary">Gerencia General</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="manager_id" label="Gerente">
              <template slot-scope="scope">
                {{
                  scope.row.gerente
                  ? `${scope.row.gerente.nombre} ${scope.row.gerente.apellido}`
                  : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="super_id" label="Superintendente">
              <template slot-scope="scope">
                {{
                  scope.row.super
                  ? `${scope.row.super.nombre} ${scope.row.super.apellido}`
                  : ""
                }}
              </template>
            </el-table-column>
            <el-table-column label="Opciones" align="center" v-if="!$store.getters.user.readonly">
              <template slot-scope="scope">
                <center>
                  <el-button @click="
                    setSeleccionTabla(scope.row._id);
                  openEditArea(scope.row);
                  " size="small" v-if="isAdmin()" icon="el-icon-edit-outline" type="primary">{{
  $t("Modificar")
}}</el-button>
                  <el-button v-if="isAdmin()" @click="deleteArea(scope.row._id)" size="small" icon="el-icon-delete"
                    type="danger">{{
                      $t("Eliminar")
                    }}</el-button>
                </center>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <br />
          <center>
            <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
              @current-change="currentPage" :page-size="6" layout="prev, pager, next" :total="totalPage">
            </el-pagination>
          </center>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { Circle9 } from "vue-loading-spinner";

const circular = (a, _id) =>
  (a && `${a._id}` === _id) || (a.area_padre && circular(a.area_padre, _id));

export default {
  data() {
    return {
      loading: false,
      loadingAction: false,
      tipoArea: "",
      listTypeAreasMEL: [
        { label: "Gerencia General", value: "gerencia_general" },
        { label: "Gerencia", value: "gerencia" },
        { label: "Superintendencia", value: "superintendencia" },
        { label: "Área", value: "area" },
        { label: "Sub Área", value: "subarea" },
      ],
      listTypeAreasSuper: [
        { label: "Área", value: "area" },
        { label: "Sub Área", value: "subarea" },
      ],
      traductionTypeArea: {
        gerencia_general: "",
        gerencia: "Gerencia General",
        superintendencia: "Gerencia",
        area: "Superintendencia",
        subarea: "Área",
      },
      assets: [],
      hasSuperintendente: false,
      operaciones: [],
      gerencias: [],
      superintendencias: [],
      areas: [],
      subAreas: [],
      arbol: [],
      classGerencia: null,
      classSuperintendencia: null,
      classAreas: null,
      classSubAreas: null,
      classOperacion: null,
      classAsset: null,
      nameAsset: "",
      area: {},
      dialogEditVisible: false,
      gerentes: [],
      superintendentes: [],
      organizationalTree: [],
      dialogUserVisible: false,
      dialogEditAsset: false,
      nuevoUsuario: {
        nombre: "",
        apellido: "",
        rut: "",
        email: "",
        perfil: "",
        faena_id: this.$store.getters.role.faena_id,
        area_id: "",
      },
      nuevaArea: {
        nombre: "",
        area_padre_id: "",
        manager_id: "",
        super_id: "",
        faena_id: this.$store.getters.role.faena_id,
      },
      dialogCreateArea: false,
      faenas: {
        "5a6f78337b772dcfe68241d5": "Minera Escondida",
        "5a6f78417b772dcfe68241e5": "Minera Spence",
        "5a6f784e7b772dcfe68241f4": "Minera Cerro Colorado",
        "5b48f15d6f0ed90fc02826e3": "BHP",
        "5c262b3176851b775b8bdefc": "Safety Club",
      },
      allAreas: [],
      totalPage: 0,
      paginar: false,
      page: 1,
      search: "",
      loading_table: false,
    };
  },
  computed: {
    ...mapGetters({
      users: "usersFaena",
      areasTree: "areas",
    }),
    tiposAreas() {
      switch (this.tipoArea) {
        case "gerencia_general":
          return this.listadoGerenciasGeneral || [];
          break;

        case "gerencia":
          return this.listadoGerenciasGeneral || [];
          break;

        case "superintendencia":
          return this.listadoGerencias || [];
          break;

        case "area":
          return this.listadoSuperintendencias || [];
          break;

        case "subarea":
          return this.listadoAreas || [];
          break;

        default:
          return [];
          break;
      }
    },
    listadoGerenciasGeneral() {
      let gerencias_general = [];
      for (let i = 0; i < this.arbol.operaciones.length; i++) {
        gerencias_general = gerencias_general.concat(this.arbol.operaciones[i]);
      }
      return gerencias_general;
    },
    listadoGerencias() {
      let gerencias = [];
      for (let i = 0; i < this.arbol.operaciones.length; i++) {
        gerencias = gerencias.concat(this.arbol.operaciones[i].gerencias);
      }
      return gerencias;
    },
    listadoSuperintendencias() {
      var self = this;
      let superintendencias = [];
      for (var x = 0; x < this.arbol.operaciones.length; x++) {
        for (let i = 0; i < this.arbol.operaciones[x].gerencias.length; i++) {
          superintendencias = superintendencias.concat(
            this.arbol.operaciones[x].gerencias[i].superintendencias
          );
        }
      }
      if (!this.isAdmin() && ["super"].includes(this.$store.getters.role.role)) {
        superintendencias = superintendencias.filter(function (el) {
          return el._id === self.$store.getters.role.area_id
        });
      }
      return superintendencias;
    },
    listadoAreas() {
      let areas = [];
      if (this.arbol.operaciones) {
        for (var j = 0; j < this.arbol.operaciones.length; j++) {
          for (let i = 0; i < this.arbol.operaciones[j].gerencias.length; i++) {
            for (
              let x = 0;
              x < this.arbol.operaciones[j].gerencias[i].superintendencias.length;
              x++
            ) {
              areas = areas.concat(
                this.arbol.operaciones[j].gerencias[i].superintendencias[x].areas
              );
            }
          }
        }
      }
      return areas;
    },
    listadoSubareas() {
      let subareas = [];
      if (this.arbol.operaciones) {
        for (var j = 0; j < this.arbol.operaciones.length; j++) {
          for (let i = 0; i < this.arbol.operaciones[j].gerencias.length; i++) {
            for (
              let x = 0;
              x < this.arbol.operaciones[j].gerencias[i].superintendencias.length;
              x++
            ) {
              for (
                let n = 0;
                n <
                this.arbol.operaciones[j].gerencias[i].superintendencias[x].areas
                  .length;
                n++
              ) {
                subareas = subareas.concat(
                  this.arbol.operaciones[j].gerencias[i].superintendencias[x]
                    .areas[n].subareas
                );
              }
            }
          }
        }
      }
      return subareas;
    },
  },
  components: {
    Circle9,
  },
  async created() {
    this.$store.dispatch("setSubTitle", "Administración de áreas");
    this.getArbol(this.$store.getters.role.faena_id);
    this.getAllAreas(this.$store.getters.role.faena_id, this.page);
  },
  async mounted() {
    await this.getAreasFaena().then(() => { });
    await this.getUsersFaena(this.$store.getters.role.faena_id);
    this.setGerentesSuperintendentes();
  },
  watch: {
    search() {
      this.loading = true;
      this.debounceInputSearch();
    },
    classAsset(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
      if (this.classOperacion) {
        this.classOperacion.classList.remove("background-orange");
      }
      if (this.classGerencia) {
        this.classGerencia.classList.remove("background-orange");
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove("background-orange");
      }
      if (this.classAreas) {
        this.classAreas.classList.remove("background-orange");
      }
      if (this.classSuperintendencia) {
        this.classSuperintendencia.classList.remove("background-orange");
      }
    },
    classOperacion(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
      if (this.classGerencia) {
        this.classGerencia.classList.remove("background-orange");
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove("background-orange");
      }
      if (this.classAreas) {
        this.classAreas.classList.remove("background-orange");
      }
      if (this.classSuperintendencia) {
        this.classSuperintendencia.classList.remove("background-orange");
      }
    },
    classGerencia(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove("background-orange");
      }
      if (this.classAreas) {
        this.classAreas.classList.remove("background-orange");
      }
      if (this.classSuperintendencia) {
        this.classSuperintendencia.classList.remove("background-orange");
      }
    },
    classSuperintendencia(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove("background-orange");
      }
      if (this.classAreas) {
        this.classAreas.classList.remove("background-orange");
      }
    },
    classAreas(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove("background-orange");
      }
    },
    classSubAreas(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove("background-orange");
        newVal.classList.add("background-orange");
      } else {
        newVal.classList.add("background-orange");
      }
    },
    tipoArea(newVal, oldVal) {
      this.nuevaArea.area_padre_id = "";
    },
  },
  methods: {
    ...mapActions([
      "getAreasFaena",
      "getUsersFaena",
      "editArea",
      "userExistsCreate",
      "saveArea",
    ]),
    isAdmin() {
      if (!this.$store.getters.role) return false;
      return this.$store.getters.role.admin || false;
    },
    async deleteArea(id) {
      this.$confirm(
        "Estás a punto de eliminar un área, tenga en cuenta que además se eliminarán todas las áreas que se encuentren asociadas a ella. Continuar?",
        "Información importante",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        this.$confirm(
          "Esta completamente seguro que desea eliminar el área. Continuar?",
          "Información importante",
          {
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(async () => {
          const config = {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          };
          axios
            .post(
              "/areas/remove",
              {
                _id: id,
              },
              config
            )
            .then((response) => {
              if (response.data.success === true) {
                this.$notify.success({
                  title: this.$t("Eliminada"),
                  message: this.$t("Área fué eliminada con éxito"),
                  customClass: "notification",
                });
                this.getArbol(this.$store.getters.role.faena_id);
                this.getAllAreas(this.$store.getters.role.faena_id, this.page);
                this.getAreasFaena();
                this.getUsersFaena(this.$store.getters.role.faena_id);
                this.getOrganizationalTree(this.$store.getters.role.faena_id);
              }
            });
        });
      });
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.getAllAreas(this.$store.getters.role.faena_id, this.page);
    }, 1200),
    currentPage(page) {
      this.page = page;
      this.getAllAreas(this.$store.getters.role.faena_id, page);
    },
    nextPage(page) {
      this.page = page;
      this.getAllAreas(this.$store.getters.role.faena_id, page);
    },
    backPage(page) {
      this.page = page;
      this.getAllAreas(this.$store.getters.role.faena_id, page);
    },
    getAreaPadre(id) {
      var area = this.allAreas.filter(function (el) {
        return el._id === id;
      });
      if (area.length) {
        return area[0].nombre;
      } else {
        return "";
      }
    },
    async getAllAreas(faena, page) {
      this.loading_table = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.getters.token}` },
      };
      let response = await axios.get(
        `/areas/filtro/${faena}/${page}/${this.search === "" ? undefined : this.search
        }`,
        config
      );
      this.allAreas = response.data.results;
      this.totalPage = response.data.total;
      this.paginar = response.data.paginar;
      this.loading_table = false;
    },
    setSeleccionTabla(area_id) {
      var area = this.allAreas.filter(function (el) {
        return el._id === area_id;
      });
      if (area.length > 0) {
        if (["gerencia", "gerencia_general"].includes(area[0]["tipo"])) {
          this.hasSuperintendente = false;
        } else {
          this.hasSuperintendente = true;
        }
      }
    },
    setSeleccion(response) {
      this.hasSuperintendente = response;
    },
    filtrarAreaPadres(areasTree, area) {
      // si el padre tiene como padre al id del hijo es circular
      return areasTree.filter((padre) => !circular(padre, `${area._id}`));
    },
    setearPerfilUsuario(perfil) {
      this.nuevoUsuario.perfil = perfil;
    },
    crearArea() {
      this.nuevaArea["creador"] = { _id: this.$store.getters.user._id, nombre: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}` };
      this.loadingAction = true;
      if (
        this.nuevaArea.nombre &&
        (this.nuevaArea.manager_id || this.nuevaArea.super_id)
      ) {
        const toSave = { area: this.nuevaArea };
        if (this.nuevaArea.manager_id) {
          if (this.nuevaArea.manager_id.includes("ToCreate")) {
            toSave.manager = this.gerentes.find(
              (g) => g._id === this.nuevaArea.manager_id
            );
            delete toSave.area.manager_id;
            delete toSave.manager._id;
          }
        }

        if (this.nuevaArea.super_id) {
          if (this.nuevaArea.super_id.includes("ToCreate")) {
            toSave.superintendente = this.superintendentes.find(
              (s) => s._id === this.nuevaArea.super_id
            );
            delete toSave.area.super_id;
            delete toSave.superintendente._id;
          }
        }

        this.saveArea(toSave).then(async (response) => {
          if (response.success) {
            this.getAreasFaena();
            this.getUsersFaena(this.$store.getters.role.faena_id);
            await this.getOrganizationalTree(this.$store.getters.role.faena_id);
            this.limpiarNuevaArea();
            this.limpiarNuevoUsuario();
            this.getArbol(this.$store.getters.role.faena_id);
            this.$notify.success({
              title: this.$t("Creada"),
              message: this.$t("Área creada con éxito"),
              customClass: "notification",
            });
            this.loadingAction = false;
          } else {
            this.$alert(response.message, this.$t("Atención"), {
              type: "error",
            });
            this.loadingAction = false;
          }
        });
      } else {
        this.$alert(
          this.$t(
            "Debes ingresar nombre del área y seleccionar superintendente o gerente."
          ),
          this.$t("Atención"),
          {
            type: "error",
          }
        );
        this.loadingAction = false;
      }
    },
    limpiarNuevaArea() {
      this.nuevaArea = {
        nombre: "",
        area_padre_id: "",
        manager_id: "",
        super_id: "",
        faena_id: this.$store.getters.role.faena_id,
      };
      this.dialogCreateArea = false;
      this.limpiarNuevoUsuario();
      this.tipoArea = "";
    },
    addGerenteSuperintendente() {
      const vue = this;
      if (
        this.nuevoUsuario.nombre &&
        this.nuevoUsuario.apellido &&
        this.nuevoUsuario.rut &&
        this.nuevoUsuario.email &&
        this.nuevoUsuario.perfil &&
        this.nuevoUsuario.faena_id &&
        this.nuevoUsuario.area_id
      ) {
        this.userExistsCreate(this.nuevoUsuario).then((response) => {
          if (response !== false) {
            switch (this.nuevoUsuario.perfil) {
              case "super":
                vue.superintendentes.push(response.message.ops[0]);
                break;
              case "manager":
                vue.gerentes.push(response.message.ops[0]);
                break;
              default:
                console.log("Error asignar perfil al usuario");
            }
            this.limpiarNuevoUsuario();
          } else {
            this.$alert(this.$t("El usuario ya existe"), this.$t("Atención"), {
              type: "error",
            });
          }
        });
      } else {
        this.$alert(
          this.$t(
            "Debes ingresar nombre, RUT, apellido y correo electrónico. De tener todos estos datos, y aún así sale este mensaje, por favor contactar a administrador de sistema."
          ),
          this.$t("Atención"),
          {
            type: "error",
          }
        );
      }
    },
    limpiarNuevoUsuario() {
      this.nuevoUsuario = {
        nombre: "",
        apellido: "",
        rut: "",
        email: "",
        perfil: "",
        faena_id: this.$store.getters.role.faena_id,
        area_id: "",
      };
      this.dialogUserVisible = false;
    },
    async getOrganizationalTree(faena) {
      const self = this;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.getters.token}` },
      };
      await axios.get(`/areas/arbol-bhp/${faena}`, config).then((response) => {
        self.organizationalTree = response.data;
      });
    },
    limpiarArea() {
      this.area = {};
      this.dialogEditAsset = false;
      this.dialogEditVisible = false;
    },
    editarArea() {
      this.loadingAction = true;
      if (this.area.nombre && (this.area.manager_id || this.area.super_id)) {
        this.editArea(this.area).then(async (response) => {
          if (response.success === true) {
            this.getAllAreas(this.$store.getters.role.faena_id, this.page);
            this.getAreasFaena();
            this.getUsersFaena(this.$store.getters.role.faena_id);
            await this.getOrganizationalTree(this.$store.getters.role.faena_id);
            this.getArbol(this.$store.getters.role.faena_id);
            this.limpiarArea();
            this.$notify.success({
              title: this.$t("Actualizada"),
              message: this.$t("Área actualizada con éxito"),
              customClass: "notification",
            });
            this.loadingAction = false;
          } else {
            this.$alert(response.message, "Atención", {
              type: "error",
            });
            this.loadingAction = false;
          }
        });
      } else {
        this.$alert(
          this.$t(
            "Debes ingresar nombre del área y seleccionar superintendente o gerente."
          ),
          this.$t("Atención"),
          {
            type: "error",
          }
        );
        this.loadingAction = false;
      }
    },
    setGerentesSuperintendentes() {
      this.superintendentes = [];
      this.gerentes = [];
      for (let i = 0; i < this.users.length; i++) {
        for (const e in this.users[i].roles.areas) {
          if (
            this.users[i].roles.areas[e].includes("super") ||
            this.users[i].roles.areas[e].includes("manager")
          ) {
            this.superintendentes.push(this.users[i]);
            this.gerentes.push(this.users[i]);
            break;
          }
        }
      }
    },
    openEditArea(areaSelected) {
      this.nuevoUsuario.area_id = areaSelected._id;
      const area = this.areasTree.find((elem) => elem._id === areaSelected._id);
      this.area = {
        _id: area._id,
        nombre: area.nombre,
        area_padre_id: area.area_padre_id,
        manager_id: area.gerente ? area.gerente._id : null,
        super_id: area.super ? area.super._id : null,
        super_dos_id: area.super_dos_id ? area.super_dos_id : null,
      };
      this.area.faena_id = this.$store.getters.role.faena_id;
      this.dialogEditVisible = true;
    },
    openEditAsset(asset) {
      this.area = JSON.parse(JSON.stringify(asset));
      this.dialogEditAsset = true;
    },
    modificarAsset() {
      if (this.area.nombre === "") {
        this.$notify({
          title: "Advertencia",
          message: "Para continuar debes ingresar un nombre.",
          type: "warning",
        });
      } else {
        const self = this;
        this.loadingAction = true;
        const config = {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        };
        axios.post("/areas/setFaena", this.area, config).then((response) => {
          if (response.data.success === true) {
            self.getArbol(self.$store.getters.role.faena_id);
            self.limpiarArea();
            self.loadingAction = false;
          }
        });
      }
    },
    setSubArea(subarea) {
      this.classSubAreas = event.target;
    },
    setArea(area) {
      this.classAreas = event.target;
      this.subAreas = area.subareas;
    },
    setSuperintendencia(superintendencia) {
      this.classSuperintendencia = event.target;
      this.areas = superintendencia.areas;
      this.subAreas = [];
    },
    setGerencia(gerencia) {
      this.classGerencia = event.target;
      this.superintendencias = gerencia.superintendencias;
      this.areas = [];
      this.subAreas = [];
    },
    setOperacion(operacion) {
      this.classOperacion = event.target;
      this.gerencias = operacion.gerencias;
      this.superintendencias = [];
      this.areas = [];
      this.subAreas = [];
    },
    setAsset(asset) {
      this.classAsset = event.target;
      this.operaciones = this.arbol.operaciones;
      this.gerencias = [];
      this.superintendencias = [];
      this.areas = [];
      this.subAreas = [];
    },
    getArbol(faenaId) {
      this.loading = true;
      this.$store
        .dispatch("getArbol", this.$store.getters.role.faena_id)
        .then((arbol) => {
          this.loading = false;
          this.arbol = arbol.data[0];
          this.assets = [];
          this.assets.push({
            _id: arbol.data[0]._id,
            nombre: arbol.data[0].nombre,
            asset_president: arbol.data[0].asset_president,
            n_operaciones: arbol.data[0].operaciones.length,
          });
          this.operaciones = [];
          this.gerencias = [];
          this.superintendencias = [];
          this.areas = [];
          this.subAreas = [];
        });
    },
  },
};
</script>

<style scoped>
.header {
  padding: 10px !important;
  text-align: center;
  background-color: #242424 !important;
}

.selection {
  padding: 10px;
  font-size: 13px;
  text-transform: lowercase;
}

.selection::first-letter {
    text-transform: capitalize
}

.selection:hover {
  background-color: rgb(246, 123, 47) !important;
  color: white;
}

.cursor {
  cursor: pointer;
}

.background-orange {
  background-color: rgb(246, 123, 47) !important;
  color: white;
}

.imgEdit {
  margin-top: 7px;
  cursor: pointer;
}

.right {
  text-align: right;
}

.content {
  min-height: 50vh;
}
</style>
